<template>
    <div>
        <div id="hero-banner">
            <div class="bg-parallax banner-image" data-inverted="true" data-speed="0.1" :style="bannerStyle"></div>
            <div class="overlay text-center">
                <h1 id="hero-text">PRIVACY POLICY</h1>
            </div>
        </div>

        <div class="container pt-6 pb-8">
            <privacy-policy-section />
            <what-we-collect-section />
            <info-collected-section />
            <security-and-disclosure-section />
            <use-cookies-section />
            <other-websites-section />
            <personal-info-section />
            <disclaimer-section />
            <copyright-section />
        </div>
    </div>
</template>
<script>
import { resource } from "@utils/network";
import PrivacyPolicySection from "./partials/PrivacyPolicySection";
import WhatWeCollectSection from "./partials/WhatWeCollectSection";
import InfoCollectedSection from "./partials/InfoCollectedSection";
import SecurityAndDisclosureSection from "./partials/SecurityAndDisclosureSection";
import UseCookiesSection from "./partials/UseCookiesSection";
import OtherWebsitesSection from "./partials/OtherWebsitesSection";
import PersonalInfoSection from "./partials/PersonalInfoSection";
import DisclaimerSection from "./partials/DisclaimerSection";
import CopyrightSection from "./partials/CopyrightSection";

export default {
    name: "PolicyStatementPage",
    components: {
        PrivacyPolicySection,
        WhatWeCollectSection,
        InfoCollectedSection,
        SecurityAndDisclosureSection,
        UseCookiesSection,
        OtherWebsitesSection,
        PersonalInfoSection,
        DisclaimerSection,
        CopyrightSection,
    },
    computed: {
        bannerStyle() {
            return `background-image:url('${ resource("images/about-us-header.jpg") }')`;
        }
    },
}
</script>
<style lang="css" scoped>
    #hero-banner {
        position: relative;
        height: 800px;
        overflow: hidden;
    }
    #hero-banner .banner-image {
        height: 100%;
        background-position-x: 50%;
    }
    #hero-text {
        margin: 360px 0 0 0;
        font-family: 'Montserrat', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 3.8rem;
        font-weight: 800;
        line-height: 1.5;
    }
    #hero-sub-text {
        margin-top: -20px;
        margin-bottom: -20px;
        font-family: 'Open Sans', sans-serif;
        color: white;
        text-transform: uppercase;
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.5;
    }
    #hero-banner .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        top: 0px;
    }
    .company-banner {
        width: 100%;
    }
    h2.display-3,
    h2.display-4 {
        font-family: 'Montserrat', sans-serif;
    }
    #tac-of-user-container .item-list .item-list {
        list-style: decimal;
        list-style-type: decimal;
    }
    /* ol:not(.sublist) { counter-reset: item } */
    #tac-of-user-container ol.item-list { counter-reset: item }
    #tac-of-user-container .sublist li{ display: block }
    #tac-of-user-container ol li .display-4 {
        display: inline-block;
        max-width: 98%;
    }
    #tac-of-user-container li:before {
        content: counters(item, ".") ". ";
        counter-increment: item;
        margin-left: -54px;
        margin-right: 4px;
        width: 50px;
        text-align: right;
        display: inline-block;
    }
</style>